export const show = {
    GET_SHOW_REQUESTED: 'GET_SHOW_REQUESTED',
    GET_SHOW_SUCCESS: 'GET_SHOW_SUCCESS',
    GET_SHOW_FAILED: 'GET_SHOW_FAILED',
};
  